import { FC } from 'react';
import sortBy from 'lodash/sortBy';
import styled from 'styled-components';
import { LocalContentCheckBox } from './LocalContentCheckBox';
import { CountryOut } from '../../../../store/apiLibx';
import { useTranslation } from 'react-i18next';

const CountryHeading = styled.div`
    margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .bt {
        width: 100px;
    }

    .bt ~ .bt {
        margin-left: 10px;
    }
`;

const CountryList = styled.div`
    max-height: 350px;
    overflow-y: scroll;
    overflow-x: hidden;
`;

const HR = styled.hr`
    border-top: 1px solid #7a7a7a;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
`;

interface Props {
    defaultCountryCode: string;
    selectedCountries: string[];
    onToggleCountry: (countryCode: string) => void;
    countries: CountryOut[];
    onSelectAllCountries: () => void;
    onDeselectAllCountries: () => void;
}

export const CountriesLimitedOptions: FC<Props> = props => {
    const { t } = useTranslation();
    const { selectedCountries = [] } = props;
    const mapCountry = c => (
        <LocalContentCheckBox
            key={c.code}
            isEnabled={props.defaultCountryCode !== c.code}
            isChecked={selectedCountries.indexOf(c.code) >= 0}
            onClick={() => props.onToggleCountry(c.code)}
            text={c.name}
        />
    );

    const topCountries = sortBy(
        props.countries.filter(c => c.topCountry),
        'name'
    ).map(mapCountry);
    const otherCountries = sortBy(
        props.countries.filter(c => !c.topCountry),
        'name'
    ).map(mapCountry);

    return (
        <>
            <CountryHeading>
                <span className="cold-grey" style={{ flexGrow: 1 }}>
                    {t('yourLocalContent.yourTitles.countries')}
                </span>
                <a
                    className="bt bt-bordered material-link"
                    onClick={props.onSelectAllCountries}
                    style={{ display: 'inline-flex' }}
                >
                    <i className="material-icons">check</i>
                    <span>{t('yourLocalContent.yourTitles.selectAll')}</span>
                </a>
                <a
                    className="bt bt-bordered material-link"
                    onClick={props.onDeselectAllCountries}
                    style={{ display: 'inline-flex' }}
                >
                    <i className="material-icons">{t('yourLocalContent.yourTitles.clear')}</i>
                    <span>{t('yourLocalContent.yourTitles.selectNone')}</span>
                </a>
            </CountryHeading>

            <CountryList>
                {topCountries}
                {topCountries.length > 0 && otherCountries.length > 0 ? <HR /> : null}
                {otherCountries}
            </CountryList>
        </>
    );
};
